// Debug utility for custom authentication
export const debugAuth = {
  // Log current environment configuration
  logConfig: () => {
    console.group('🔐 Custom Auth Configuration');
    console.log('Auth Provider:', process.env.REACT_APP_AUTH_PROVIDER);
    console.log('API URL:', process.env.REACT_APP_API_URL);
    console.log('API URL V2:', process.env.REACT_APP_API_URL_V2);
    console.log('Debug Mode:', process.env.REACT_APP_DEBUG_AUTH);
    console.groupEnd();
  },

  // Log current authentication state
  logAuthState: () => {
    console.group('🔐 Current Auth State');
    const accessToken = localStorage.getItem('access-token');
    const refreshToken = localStorage.getItem('refresh-token');
    const userData = localStorage.getItem('user-data');

    console.log('Access Token:', accessToken ? 'Present' : 'Missing');
    console.log('Refresh Token:', refreshToken ? 'Present' : 'Missing');
    console.log('User Data:', userData ? 'Present' : 'Missing');

    if (userData) {
      try {
        const user = JSON.parse(userData);
        console.log('User:', user);
      } catch (e) {
        console.log('User Data (invalid JSON):', userData);
      }
    }
    console.groupEnd();
  },

  // Log API request details
  logApiRequest: (config: any) => {
    console.group('🌐 API Request');
    console.log('URL:', config.url);
    console.log('Method:', config.method);
    console.log('Base URL:', config.baseURL);
    console.log('Headers:', config.headers);
    console.log('Data:', config.data);
    console.groupEnd();
  },

  // Log API response details
  logApiResponse: (response: any) => {
    console.group('✅ API Response');
    console.log('Status:', response.status);
    console.log('Headers:', response.headers);
    console.log('Data:', response.data);
    console.groupEnd();
  },

  // Log API error details
  logApiError: (error: any) => {
    console.group('❌ API Error');
    console.log('Status:', error.response?.status);
    console.log('Status Text:', error.response?.statusText);
    console.log('Headers:', error.response?.headers);
    console.log('Data:', error.response?.data);
    console.log('Config:', error.config);
    console.groupEnd();
  },

  // Test API connectivity
  testApiConnectivity: async () => {
    console.group('🔍 API Connectivity Test');

    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      console.log('Testing API URL:', apiUrl);

      // Test basic connectivity
      const response = await fetch(`${apiUrl}/health`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      console.log('Health check status:', response.status);
      console.log('Health check response:', await response.text());
    } catch (error) {
      console.error('API connectivity test failed:', error);
    }

    console.groupEnd();
  },

  // Test auth endpoints
  testAuthEndpoints: async () => {
    console.group('🔍 Auth Endpoints Test');

    try {
      const apiUrl = process.env.REACT_APP_API_URL;

      // Test send-otp endpoint
      console.log('Testing /otp/send-otp endpoint...');
      const otpResponse = await fetch(`${apiUrl}/otp/send-otp`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: 'test@example.com',
        }),
      });

      console.log('Send OTP status:', otpResponse.status);
      console.log('Send OTP response:', await otpResponse.text());
    } catch (error) {
      console.error('Auth endpoints test failed:', error);
    }

    console.groupEnd();
  },

  // Clear all auth data
  clearAuthData: () => {
    console.log('🧹 Clearing all auth data...');
    localStorage.removeItem('access-token');
    localStorage.removeItem('refresh-token');
    localStorage.removeItem('user-data');
    localStorage.removeItem('token');
    console.log('Auth data cleared');
  },

  // Enable debug mode
  enable: () => {
    if (typeof window !== 'undefined') {
      (window as any).debugAuth = debugAuth;
      console.log('🔧 Debug utilities available at window.debugAuth');
      console.log('Available methods:');
      console.log('- debugAuth.logConfig()');
      console.log('- debugAuth.logAuthState()');
      console.log('- debugAuth.testApiConnectivity()');
      console.log('- debugAuth.testAuthEndpoints()');
      console.log('- debugAuth.clearAuthData()');
    }
  },
};

// Auto-enable debug mode in development
if (process.env.NODE_ENV === 'development') {
  debugAuth.enable();
}
